module.exports = __webpack_public_path__ + "img/arrowNewsletter.d1f4712c.svg";